import { render, staticRenderFns } from "./ProductLastPrice.vue?vue&type=template&id=7ceecd42&scoped=true&"
import script from "./ProductLastPrice.vue?vue&type=script&lang=js&"
export * from "./ProductLastPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceecd42",
  null
  
)

export default component.exports